import { render, staticRenderFns } from "./AssignedClasses.vue?vue&type=template&id=11c6b9d9&scoped=true&"
import script from "./AssignedClasses.vue?vue&type=script&lang=js&"
export * from "./AssignedClasses.vue?vue&type=script&lang=js&"
import style0 from "./AssignedClasses.vue?vue&type=style&index=0&id=11c6b9d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c6b9d9",
  null
  
)

export default component.exports